function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { forwardRef } from "react";
import Button from "../Button";
import { useFormManager } from "./FormCore";
const Submit = /*#__PURE__*/forwardRef(({
  as: Component = Button,
  ...props
}, ref) => {
  const {
    onSubmit
  } = useFormManager();
  return /*#__PURE__*/React.createElement(Component, _extends({}, props, {
    ref: ref,
    type: "button",
    onClick: onSubmit
  }));
});
export default Submit;